import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private _mainPageTitle = signal<string>('');
  mainPageTitle: Signal<string> = this._mainPageTitle.asReadonly();

  setPageTitle(newTitle: string): void {
    this._mainPageTitle.set(newTitle);
  }
}
